// CrystalVault — shared withdrawal fee math (mirrors CrystalVaultV3_4.sol).
//
// Read-only helpers used by withdraw and claim previews across pages. Any page
// that shows a "you receive" number MUST apply _computeWithdrawalFee —
// otherwise users see gross amounts and are surprised at claim time.

// `performanceFeeBps` → display string. 2000 → "20%", 1500 → "15%", 250 → "2.5%".
export function formatPerfPct(bps) {
  const pct = Number(bps) / 100;
  return (Number.isInteger(pct) ? pct.toFixed(0) : pct.toFixed(1)) + "%";
}

// `builderFeeRate` is in HL "f" units: each step = 0.001%. f=35 → "0.035%".
export function formatBuilderPct(rate) {
  return (Number(rate) * 0.001).toFixed(3) + "%";
}

// Cost-basis-proportional perf fee, floor rounding. All inputs BigInt in base
// units. Matches CrystalVaultV3_4.sol `_calculateFee` exactly so the UI preview
// never diverges from what `claimWithdraw` actually charges.
export function computeWithdrawalFee(sharesBurn, totalShares, totalCostBasis, grossAssets, perfFeeBps) {
  if (perfFeeBps === 0n || grossAssets === 0n || sharesBurn === 0n || totalShares === 0n) return 0n;
  const proportionalCost = (totalCostBasis * sharesBurn) / totalShares;
  if (grossAssets <= proportionalCost) return 0n;
  const profit = grossAssets - proportionalCost;
  return (profit * perfFeeBps) / 10000n;
}
